import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import ManagerHeader from "../manager-dashboard/ManagerHeader.js";
import api from "../../api/axios.js";
import ManagerSelectedEmployeeCard from "./ManagerSelectedEmployeeCard.js";


const ManagerFeedbackForm = () => {

  const navigate = useNavigate();
  const { employeeId, quizId } = useParams();
  const location = useLocation();

  const managerId = "101";

  const quizTitle = location.state?.quizTitle || "Pre-job Preparation";

  const [employee, setEmployee] = useState(null);
  const [showMessage, setShowMessage] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const [message, setMessage] = useState("");

  useEffect(() => {
    api
      .get(`/api/feedback/employee/${employeeId}`)
      .then((res) => {

        setEmployee(res.data);
      })
      .catch((err) =>{

        console.log(err);
      });
  }, [employeeId]);

  const feedbackTemplates = [
    "You're doing a great job so far. With a little more practice, you'll feel even more confident.",
    "Nice work overall! You're getting the hang of things, and your progress is really showing.",
    "Amazing job! You handled everything smoothly and showed great confidence throughout your work.", 
  ];

  const handleTemplateClick = (text) => {
    setMessage(text);
  }

  const handleSave = async() => {
    try{
      const body = {
        employeeId: employeeId,
        quizId: quizId,
        quizTitle: quizTitle,
        managerId: managerId,
        message: message,
      }
      await api.post("/api/feedback", body);

      setAlertMessage(`Your feedback for ${quizTitle} has been updated to ${employee?.employeeName}`);
      setShowMessage(true);
    }catch(err){
      console.log(err);
    }
  };

  if(!employee) return <p>Loading...</p>

  return (
    <>
      <div className="dashboard-wrapper">
        <ManagerHeader />    

        <div className="manager_feedback_form_box">

          <div className="manager_feedback_form_employee_photoside">
            {showMessage && (
            <div className="feedback_alert">
              {alertMessage}
              <button className="alert_close" onClick={() => setShowMessage(false)}><img src="/images/close-window.png" alt="window-close"/></button>
            </div>
            )}

            <ManagerSelectedEmployeeCard
              title={`You are giving feedback for ${employee.employeeName}`}
              employee={employee} />
          </div>

          <div className="manager_feedback_form_manager_feedbackside">
          
          <p className="manager_feedback_input_quiztitle">{quizTitle}</p>
          <p className="manager_feedback_inputtitle">You are giving feedback for {employee.employeeName} on {quizTitle}</p>

          <div className="feedback_template">
            {feedbackTemplates.map((text, index) => {
              return(
                <button
                key={index}
                type="button"
                className="template_btn"
                onClick={() => handleTemplateClick(text)}>{text}</button>
              );
            })}
          </div>
          <textarea 
            className="manager_feedback_box"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            />
          <div className="btn-wrapper">
          <button className="manager_feedback_submit_btn" type="button" onClick={handleSave}>
            Submit
          </button>
        </div>
        </div>
      </div>
      </div>
    </>
  )
}

export default ManagerFeedbackForm;